import type { DocumentContext } from '../domain/DocumentContext';

export function getMockDocumentContext(): DocumentContext {
  const today = new Date().toISOString().slice(0, 10);

  return {
    today,
    quote: {
      number: 'Q-1042',
      title: 'Foundation Pour — Building A',
      date: '2026-04-15',
      valid_until: '2026-05-15',
      valid_days: 30,
      status: 'Draft',
      po_number: 'PO-44219',
      description: 'Concrete pump & placement — foundation pour for Building A.'
    },
    customer: {
      name: 'Acme Construction',
      address: '1200 Industrial Pkwy, Denver, CO 80216',
      city: 'Denver',
      state: 'CO',
      industry: 'General Contractor',
      tags: ['VIP', 'Net-30']
    },
    contact: {
      name: 'Jane Roberts',
      email: 'jane@acmecon.com',
      phone: '(555) 201-3344',
      title: 'Project Manager'
    },
    user: {
      name: 'Ben Whitaker',
      email: 'ben.whitaker@rapidservices.co',
      phone: '(555) 201-7788'
    },
    opportunity: {
      name: 'Acme Foundation 2026',
      stage: 'Negotiation'
    },
    scope: {
      job_site_count: 2,
      phase_count: 1,
      line_item_count: 14,
      pour_type: 'Slab',
      volume_cy: '42'
    },
    totals: {
      subtotal: 12450,
      discount_amount: 0,
      surcharge_amount: 150,
      tax_amount: 996,
      grand_total: 13596
    },
    date: {
      today
    },
    lineItems: [],
    priceBook: [
      {
        id: '1',
        name: 'Equipment — Boom pump — 42m',
        description: 'Standard placement',
        unit: 'hour',
        rate: 325,
        ot_rate: 487.5,
        ot_rate_2: 650,
        volume_rate: 12.5,
        min_charge: 800
      },
      {
        id: '2',
        name: 'Equipment — Line pump',
        description: 'Line pour',
        unit: 'hour',
        rate: 275,
        ot_rate: 412.5,
        ot_rate_2: 550,
        volume_rate: 10,
        min_charge: 600
      },
      {
        id: '103',
        name: 'Role — Operator',
        description: 'Certified pump operator',
        unit: 'hour',
        rate: 78,
        ot_rate: 93.6,
        ot_rate_2: 109.2,
        volume_rate: 0,
        min_charge: 0
      }
    ]
  };
}
